import { requestInventory } from '../../dataSource/itinerary/itinerary.requests'
import { PARAM_ARRIVAL_DATE_TIME, PARAM_DEPARTURE_DATE_TIME } from '../../domain/router/queryParameters.constants'
import { getCurrentDateISO } from '../../domain/utils/date'
import { selectLocale } from '../navigation/navigation.selectors'
import {
  extractDefaultFuelPrices,
  extractDefaultVehiculeOptions,
  extractTransportModes
} from './itineraryOptions.dataParsers'
import {
  setDefaultFuelPrices,
  setDefaultVehicleOptions,
  setItineraryArrivalLater,
  setItineraryDate,
  setItineraryDepartureLater,
  setItineraryTime,
  setPreferredOptionsForMode
} from './itineraryOptionsSlice'

const fetchVehiclesOptions = () => (dispatch, getState) => {
  const locale = selectLocale(getState())

  return requestInventory(locale).then(data => {
    const vehiclesOptions = extractDefaultVehiculeOptions(data)
    const transportModes = extractTransportModes(data)

    dispatch(
      setDefaultVehicleOptions({
        vehiclesOptions,
        transportModes
      })
    )

    const fuelPrices = extractDefaultFuelPrices(data)

    dispatch(
      setDefaultFuelPrices({
        fuelPrices
      })
    )
  })
}

let mustFetchItineraryOptions = true

export const fetchItineraryOptionsConfig = () => (dispatch, getState) => {
  if (mustFetchItineraryOptions) {
    mustFetchItineraryOptions = false
    return fetchVehiclesOptions()(dispatch, getState)
  }

  return Promise.resolve()
}

export const reinitializeFetchItineraryOptionConfig = () => (mustFetchItineraryOptions = true)

export const changePreferredOptions =
  ({ modeId, ...newPreferredOptionsForMode }) =>
  (dispatch, getState) => {
    dispatch(
      setPreferredOptionsForMode({
        modeId,
        ...newPreferredOptionsForMode
      })
    )
  }

const REGEX_DATETIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/

const checkDateTimeQueryParams = dateTimeQueryParam => {
  if (REGEX_DATETIME.test(dateTimeQueryParam)) {
    const { date } = splitDateTimeFromQueryParams(dateTimeQueryParam)
    const inputDate = new Date(date)
    const now = new Date(getCurrentDateISO())
    return inputDate >= now
  }
  return false
}

const splitDateTimeFromQueryParams = dateTimeQueryParam => {
  const [date, time] = dateTimeQueryParam.split('T')
  return { date, time }
}

const setDateTimeFromQueryParams = dateTimeQueryParam => dispatch => {
  const { date, time } = splitDateTimeFromQueryParams(dateTimeQueryParam)
  dispatch(setItineraryDate({ date }))
  dispatch(setItineraryTime({ time }))
}

export const setItineraryTimeOptionsFromQueryParams = query => (dispatch, getState) => {
  if (query.has(PARAM_ARRIVAL_DATE_TIME)) {
    const datetimeParam = query.get(PARAM_ARRIVAL_DATE_TIME)
    if (checkDateTimeQueryParams(datetimeParam)) {
      dispatch(setItineraryArrivalLater())
      setDateTimeFromQueryParams(datetimeParam)(dispatch)
    }
  } else if (query.has(PARAM_DEPARTURE_DATE_TIME)) {
    const datetimeParam = query.get(PARAM_DEPARTURE_DATE_TIME)
    if (checkDateTimeQueryParams(datetimeParam)) {
      dispatch(setItineraryDepartureLater())
      setDateTimeFromQueryParams(datetimeParam)(dispatch)
    }
  }
}
